import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { VersionService } from '../../services/version.service';
import { VersionInfo, ReleaseNote } from '../../version';

@Component({
  selector: 'app-version-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './version-info.component.html',
  styleUrl: './version-info.component.css'
})
export class VersionInfoComponent implements OnInit, OnDestroy {
  isOpen = false;
  currentVersion?: VersionInfo;
  versionHistory: ReleaseNote[] = [];
  selectedTab: 'current' | 'history' = 'current';
  selectedReleaseTab: 'summary' | 'backend' | 'frontend' = 'summary';
  selectedRelease?: ReleaseNote;

  private subscriptions = new Subscription();

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.versionService.getCurrentVersion().subscribe(version => {
        this.currentVersion = version;
      })
    );

    this.subscriptions.add(
      this.versionService.getVersionHistory().subscribe(history => {
        this.versionHistory = history;
        if (history.length > 0) {
          this.selectedRelease = history[0];
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  selectTab(tab: 'current' | 'history'): void {
    this.selectedTab = tab;
  }

  selectReleaseTab(tab: 'summary' | 'backend' | 'frontend'): void {
    this.selectedReleaseTab = tab;
  }

  selectRelease(release: ReleaseNote): void {
    this.selectedRelease = release;
    this.selectedReleaseTab = 'summary';
  }

  getVersionBadgeClass(type: 'major' | 'minor' | 'patch'): string {
    return this.versionService.getVersionBadgeClass(type);
  }

  getVersionIcon(type: 'major' | 'minor' | 'patch'): string {
    return this.versionService.getVersionIcon(type);
  }

  getChangeCount(release: ReleaseNote): number {
    return (
      (release.backend.features?.length || 0) +
      (release.backend.improvements?.length || 0) +
      (release.backend.bugFixes?.length || 0) +
      (release.frontend.features?.length || 0) +
      (release.frontend.improvements?.length || 0) +
      (release.frontend.bugFixes?.length || 0)
    );
  }
}
